import React, {useEffect, useState} from "react";
import Head from "next/head";

export default function GTagHeader(props: any) {
  const [googleTagData, setGoogleTagData] = useState({
    gtmId: '',
    measurementId: '',
    conversionId: ''
  });

  const loadGoogleTags = () => {
    return (
      <Head>
        <script src={`https://www.googletagmanager.com/gtag/js?id=${googleTagData.conversionId}`} async/>
        <script src={`https://www.googletagmanager.com/gtag/js?id=${googleTagData.measurementId}`} async/>
        <script dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${googleTagData.gtmId}');
          
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
            
          gtag('config', '${googleTagData.conversionId}');
          gtag('config', '${googleTagData.measurementId}', {
            page_path: window.location.pathname,
          });
          `
        }}></script>
      </Head>
    )
  }

  useEffect(() => {
    const hostname = window.location.hostname.toLowerCase();

    if (hostname.includes('musix') || hostname.includes('.mus.')) {
      setGoogleTagData({
        gtmId: 'GTM-PQ4CGXQ',
        measurementId: 'G-4XD670473X',
        conversionId: 'AW-1061256667'
      });
    } else if (hostname.includes('venoa') || hostname.includes('.ven.')) {
      setGoogleTagData({
        gtmId: 'GTM-M3VFM8Z',
        measurementId: 'G-YSQZXJH3D3',
        conversionId: 'AW-601914124'
      });
    }
  }, []);

  return (
    <>
      {googleTagData.gtmId && loadGoogleTags()}
      {props.children}
    </>
  )
}